import { useState } from 'react';
import {
	addEmails,
	getDefaultSelectedEmails,
	getSelectedRecipientEmails,
	removeEmails,
	toggleEmail
} from '../../helpers/partnerPreviewRecipients';

/*
 * Which recipients are ticked (named and default export, like useFleetFirmwareVersions). Only the user's deviation from the defaults is state (`override`, null until
 * the first click); the selection itself is derived while rendering. Copying the defaults into state from an
 * effect would commit one render with nothing selected as soon as the list arrives (a flashed validation
 * message and a disabled Confirm), and would overwrite the user's picks whenever the list was replaced.
 * `selectedEmails` only ever holds addresses of `recipients` (in the list's order), so the counter, Confirm
 * and the request body read the same array.
 */
export const useRecipientSelection = (recipients) => {
	const [override, setOverride] = useState(null);
	const selectedEmails = getSelectedRecipientEmails(recipients, override ?? getDefaultSelectedEmails(recipients));

	const updateSelection = (update) => {
		setOverride((currentOverride) => {
			return update(
				getSelectedRecipientEmails(recipients, currentOverride ?? getDefaultSelectedEmails(recipients))
			);
		});
	};

	return {
		selectedEmails,
		toggle: (email) => {
			return updateSelection((current) => {
				return toggleEmail(current, email);
			});
		},
		selectAll: (emails) => {
			return updateSelection((current) => {
				return addEmails(current, emails);
			});
		},
		clearAll: (emails) => {
			return updateSelection((current) => {
				return removeEmails(current, emails);
			});
		}
	};
};

export default useRecipientSelection;
